/**
 * @fileoverview Which review list a Sales Pipeline viewer works from.
 * @description A Sales Executive submits prospects for review rather than reviewing them, so they
 * see their own submissions (`context=SUBMITTED`); everyone else sees the requests routed to them
 * (`context=REVIEW`) — Confluence 3.5.12.1.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import type { ApprovalListContext } from '@/features/sales/types/approval.types'

/**
 * @description The review list a viewer works from.
 * @param {string} viewerRole - The viewer's active role name.
 * @returns {ApprovalListContext} SUBMITTED for a Sales Executive, REVIEW otherwise.
 */
export function approvalContextFor(viewerRole: string): ApprovalListContext {
  return viewerRole === 'Sales Executive' ? 'SUBMITTED' : 'REVIEW'
}
